/* unplugin-vue-components disabled */import { render } from "./F3DScaleBRender.vue?vue&type=template&id=dd526a58&scoped=true"
import script from "./F3DScaleBRender.vue?vue&type=script&lang=js"
export * from "./F3DScaleBRender.vue?vue&type=script&lang=js"

import "./F3DScaleBRender.vue?vue&type=style&index=0&id=dd526a58&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd526a58"]])

export default __exports__